var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.Running.category == _vm.title || (_vm.Running.nav && _vm.Running.nav.item && _vm.Running.nav.item.title === _vm.title))?_c('div',{staticClass:"GameCreditCategory u-bl u-br"},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }